import { Credentials, DemoRole, EnvironmentMode } from '@src/molecules/DemoForm/types';
import { DEMO_CREDENTIALS } from '@src/molecules/DemoForm/const';

/**
 * Returns demo credentials based on the specified environment mode
 * @param mode - Environment mode ('dev', 'stage', or 'prod')
 * @returns Object containing GMR and GMA credentials
 */
export const getDemoCredentials = (mode: EnvironmentMode): Record<DemoRole, Credentials> => {
  if (!DEMO_CREDENTIALS[mode]) {
    throw new Error(`Invalid mode: ${mode}. Expected 'dev', 'stage', or 'prod'`);
  }
  return DEMO_CREDENTIALS[mode];
};
